import React       from 'react';
import ReactDom    from 'react-dom';
// -------------------------------------------------------

class InputNum extends React.Component {
  update() {
    this.props.update_ev.bind(this)(this.item.value);
  }
  
  render() {
    let data = this.props.data;
    
    return (
      <input className="text" type="number" ref={(input) => { this.item = input }} onChange={this.update.bind(this)} defaultValue={data.default} placeholder={data.name +'を入力してください'} />
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InputNum;